'use strict';

module.exports = {
    // sections
    root: 'root',
    system: 'system',
    network: 'network',
    video: 'video',
    audio: 'audio',
    parentControl: 'parentControl',
    userInterface: 'userInterface',
    ethernet: 'ethernet',
    theme: 'theme',

    // options
    loadEmbeddedPortal: 'loadEmbeddedPortal',
    deviceInfo: 'deviceInfo',
    interfaceLanguage: 'interfaceLanguage',
    deviceTimezone: 'deviceTimezone',
    restartPortal: 'restartPortal',
    rebootDevice: 'rebootDevice',
    resetDeviceUserSettings: 'resetDeviceUserSettings',
    parentControlStatus: 'parentControlStatus',
    parentControlSessionTime: 'parentControlSessionTime',
    parentControlPassword: 'parentControlPassword'
};
